
import {
  ProductFamilyDto,
  CreateProductFamilyDto,
  UpdateProductFamilyDto,
} from './dtos'
import { BaseCrudService } from './BaseCrudService'
import { axios, PaginatedQueryBase } from './api'

export type ProductFamiliesFilters = PaginatedQueryBase & {
  includeInactive?: boolean
  search?: string
}

class ProductFamilyService extends BaseCrudService<
  ProductFamilyDto,
  CreateProductFamilyDto,
  UpdateProductFamilyDto,
  ProductFamiliesFilters
> {
  constructor() {
    super('product-family', process.env.REACT_APP_RADIOPHARMACY_API_URL)
  }

  move(id: string, direction: 'up' | 'down'): Promise<void> {
    return new Promise((resolve, reject) => {
      const configs = {
        method: 'post',
        url: `${this.endpoint}/${id}/move/${direction}`,
        ...this.configOptions,
      }
      axios(configs, resolve, reject)
    })
  }
}

export const productFamilyService = new ProductFamilyService()
